import { DropzoneOptions, useDropzone } from 'react-dropzone';

export type UseFileDropzoneOptions = Omit<DropzoneOptions, 'useFsAccessApi'> &
  Required<Pick<DropzoneOptions, 'onDrop'>>;

export function useFileDropzone(options: UseFileDropzoneOptions) {
  return useDropzone({
    ...options,
    useFsAccessApi: false,
  });
}
